'use client';
import React from 'react';

import { IsKocAliemValidatedProvider } from '@contexts/loyalty/KocAilem';
import {
  ResourceIdProvider,
  SearchURLProvider,
  SsrDataProvider,
} from '@api/data-loaders/resource';

import HotelProvider from './context';
import HotelDetail from './HotelDetail';
import { DetailContainer } from './HotelDetailStyle';

interface HotelDetailScreenProps {
  metaInfo?: Record<string, string>;
  data?: any;
  initialData?: any;
  conceptHotelInitialData?: any;
}
const HotelDetailScreen = ({
  initialData,
  data,
  conceptHotelInitialData,
}: HotelDetailScreenProps) => {
  return (
    <ResourceIdProvider value={data?.props?.resourceKey}>
      <SsrDataProvider value={data}>
        <SearchURLProvider value={data?.props?.urlSearch}>
          <IsKocAliemValidatedProvider>
            <HotelProvider>
              <DetailContainer>
                <HotelDetail
                  initialData={initialData}
                  conceptHotelInitialData={conceptHotelInitialData}
                />
              </DetailContainer>
            </HotelProvider>
          </IsKocAliemValidatedProvider>
        </SearchURLProvider>
      </SsrDataProvider>
    </ResourceIdProvider>
  );
};

export default HotelDetailScreen;
